import Styles from './styles.module.css';
import '../../auth/login/tokens.css';
import React, { useEffect, useRef } from 'react';

import Plan from "./1.plan/index";
import Icon from "./2.icon/index";
import JobPostings from "./3.school/index";
import Sending from "./4.sending/index";
import Complete from "./5.complete/index";

import logoCompany from './../../../image/icon_black.png';
import { GoCheck } from "react-icons/go";

import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector } from 'src/salon/app/hook';

type ManualProps = {
  companyId: string;
};

// ルートの path と表示ラベル。順序がそのまま進捗になる。
const STEPS = [
  { key: 'plan', label: 'プラン' },
  { key: 'icon', label: '基本設定' },
  { key: 'job', label: '求人情報' },
  { key: 'sending', label: '送付先' },
  { key: 'complete', label: '完了' },
] as const;

const Manual: React.FC<ManualProps> = ({ companyId }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const company = useAppSelector((state) => state.company.company);

  // -------------------------
  // 🔥 Firestore → URL同期
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!company?.id || !company?.progress) return;

    const progress = company.progress;

    const step =
      !progress.plan ? "plan" :
      !progress.icon ? "icon" :
      !progress.jobPostings ? "job" :
      !progress.sending ? "sending" :
      "complete";

    const current = location.pathname.split("/").pop();

    // すでに正しい場所なら何もしない
    if (current === step) return;

    navigate(`/service/manual/${step}`, { replace: true });
  }, [company?.id, company?.progress]);

  // ステップ遷移時は先頭までスクロールを戻す
  // （SPA 遷移だとブラウザが前ページのスクロール位置を引き継ぐため）
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);


  const currentStep = location.pathname.split("/").pop();
  const currentIndex = Math.max(0, STEPS.findIndex((s) => s.key === currentStep));

  return (
    <>
      {/* ステップナビ */}
      <div className={Styles.navigation}>
        <img className={Styles.navigation_logo} src={logoCompany} alt='memorii recruit' />

        <ol className={Styles.progress}>
          {STEPS.map((s, i) => {
            const state = i < currentIndex ? 'done' : i === currentIndex ? 'current' : 'upcoming';
            return (
              <li
                key={s.key}
                className={[Styles.step, Styles[state]].filter(Boolean).join(' ')}
                aria-current={state === 'current' ? 'step' : undefined}
              >
                <span className={Styles.step_marker}>
                  {state === 'done' ? <GoCheck className={Styles.step_check} /> : i + 1}
                </span>
                <span className={Styles.step_label}>{s.label}</span>
              </li>
            );
          })}
        </ol>
      </div>

      {/* コンテンツ */}
      <Routes>
        <Route path="/" element={<Navigate to="plan" />} />
        <Route path="plan" element={<Plan />} />
        <Route path="icon" element={<Icon />} />
        <Route path="job" element={<JobPostings />} />
        <Route path="sending" element={<Sending />} />
        <Route path="complete" element={<Complete />} />
      </Routes>
    </>
  );
};

export default Manual;
